import styled from 'styled-components';
import { FullWidthStyledInput } from '@Safemate/RoleEditor/FormStyles';

/* Vertical list of weekday rows */
export const ScheduleWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.colors.borderRadius};
  overflow: hidden;
  background: ${props => props.theme.colors.backgroundSecondary};
`;

/* Shared column template so the header and every day row line up */
const rowGrid = `
  display: grid;
  grid-template-columns: minmax(96px, 1fr) auto minmax(72px, 116px) 14px minmax(72px, 116px);
  align-items: center;
  column-gap: 16px;
  padding: 12px 18px;

  @media (max-width: 620px) {
    grid-template-columns: 1fr auto;
    row-gap: 10px;
  }
`;

export const ScheduleHeader = styled.div`
  ${rowGrid}
  padding-top: 14px;
  padding-bottom: 14px;
  background: ${props => props.theme.colors.backgroundPrimary};
  border-bottom: 1px solid ${props => props.theme.colors.borderColor};

  @media (max-width: 620px) {
    display: none;
  }
`;

export const HeaderLabel = styled.span`
  font-size: ${props => props.theme.font.small};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${props => props.theme.colors.textSecondary};
  text-align: center;
`;

export const DayRow = styled.div<{ active?: boolean }>`
  ${rowGrid}
  border-bottom: 1px solid ${props => props.theme.colors.borderColor};

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 620px) {
    align-items: start;
  }
`;

export const DayName = styled.span<{ active?: boolean }>`
  font-size: ${props => props.theme.font.normal};
  font-weight: ${props => (props.active ? 600 : 400)};
  color: ${props =>
    props.active ? props.theme.colors.textPrimary : props.theme.colors.textSecondary};
  opacity: ${props => (props.active ? 1 : 0.75)};

  &::first-letter {
    text-transform: uppercase;
  }
`;

/* Wrapper around each time input so it can dim when the day is off */
export const TimeCell = styled.div<{ disabled?: boolean }>`
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  transition: opacity 0.15s ease;

  @media (max-width: 620px) {
    min-width: 96px;
  }
`;

export const RangeDash = styled.span<{ disabled?: boolean }>`
  text-align: center;
  color: ${props => props.theme.colors.textSecondary};
  opacity: ${props => (props.disabled ? 0.4 : 0.7)};
`;

/* On small screens the time range drops onto its own line spanning the row */
export const TimeGroup = styled.div<{ single?: boolean }>`
  display: contents;

  @media (max-width: 620px) {
    display: grid;
    grid-column: 1 / -1;
    grid-template-columns: ${props => (props.single ? '1fr' : '1fr 14px 1fr')};
    align-items: center;
    column-gap: 12px;
  }
`;

export const TimeInput = styled(FullWidthStyledInput)`
  height: 40px;
  line-height: normal;
  text-align: center;
  padding-left: 0;
`;

/* Hint shown in the time columns when a day is switched off */
export const OffLabel = styled.span`
  grid-column: 3 / -1;
  font-size: ${props => props.theme.font.small};
  color: ${props => props.theme.colors.textSecondary};
  opacity: 0.7;
  font-style: italic;

  @media (max-width: 620px) {
    grid-column: 1 / -1;
  }
`;